import React from 'react';
import { bool, func, object } from 'prop-types';

import cx from 'clsx';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/styles';

import styles from './styles';

const useStyles = makeStyles(styles);

export function NestedApplication({ active, application, onSelect }) {
  const classes = useStyles();

  const handleSelect = React.useCallback(() => onSelect(application), [
    application,
    onSelect,
  ]);

  return (
    <ListItem
      button
      className={cx(classes.container, { active })}
      onClick={handleSelect}
    >
      <ListItemText
        disableTypography
        className={cx(classes.text, { active })}
        primary={application.name}
      />
    </ListItem>
  );
}

NestedApplication.propTypes = {
  /* own props */
  application: object.isRequired,
  active: bool.isRequired,
  onSelect: func.isRequired,
};

export default React.memo(NestedApplication);
